import { useEffect, useState } from "react";
import { db, IBlock } from "../database";

const useBlocks = (siteId: any) => {
	const [blocks, setBlocks] = useState<IBlock[]>();
	useEffect(() => {
		const getBlocks = async () => {
			if (!siteId) {
				return blocks;
			}
			const blocksBySiteId = await db.blocks
				.where("siteId")
				.equals(Number(siteId))
				.toArray();
			setBlocks(blocksBySiteId);
		};
		getBlocks();
	}, [siteId]);
	return blocks;
};

export default useBlocks;
